import Reveal from "./Reveal";
import { PROCESS } from "@/data/content";

const Process = () => {
  return (
    <section
      id="processo"
      className="relative py-24 lg:py-32 max-w-7xl mx-auto px-6 lg:px-10"
      data-testid="process-section"
    >
      <Reveal>
        <p className="font-mono-accent text-xs text-[#00D2D3] tracking-[0.25em] uppercase mb-4">
          Como trabalhamos
        </p>
        <h2 className="font-outfit font-bold text-3xl sm:text-4xl text-white max-w-2xl tracking-tight">
          Processo transparente, do briefing à operação.
        </h2>
      </Reveal>

      <div className="relative mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
        <div className="hidden md:block absolute top-6 left-0 right-0 h-px bg-white/10" />
        {PROCESS.map((step, i) => (
          <Reveal delay={i * 0.15} key={step.index}>
            <div
              className="relative flex flex-col"
              data-testid={`process-step-${step.index}`}
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="relative flex items-center justify-center w-12 h-12 rounded-full border border-[#00D2D3]/40 bg-[#0a0a0a] font-mono-accent text-[#00D2D3] text-sm z-10">
                  {step.index}
                </div>
                <span className="text-xs font-mono-accent uppercase tracking-widest text-white/40 border border-white/10 rounded-full px-3 py-1">
                  {step.tag}
                </span>
              </div>
              <h3 className="font-outfit font-bold text-xl sm:text-2xl text-white mb-3">
                {step.title}
              </h3>
              <p className="text-white/55 font-manrope text-sm sm:text-base leading-relaxed">
                {step.description}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Process;
